






















































import { GeekItem } from '@/models';
import { WaitingRequest, WaitingWithdrawalAcceptForm } from '@/models/admin-panel';
import { ToastsService, buildGeekName, resetModel } from '@/utils';
import { Actions } from '@/store';
import Vue from 'vue';

export default Vue.extend({
  name: 'AcceptRequestModal',
  props: {
    waitingRequest: Object as () => WaitingRequest,
  },
  data() {
    return {
      form: {
        reason: '',
        gCoins: 0,
      },
      loader: {
        isRequestPending: false,
      },
    };
  },
  computed: {
    geekName(): string {
      return buildGeekName(this.waitingRequest?.geek);
    },
    hasNoGCoins(): boolean {
      return this.geeksBalance < 1;
    },
    geeksBalance(): number {
      return this.waitingRequest?.geeksBalance;
    },
    gCoinsLimit(): number {
      return Math.min(this.geeksBalance, 10000);
    },
    reason(): string {
      return this.waitingRequest?.reason;
    },
  },
  methods: {
    async acceptRequest() {
      const valid = await this.$validator.validate();

      if (!valid) {
        return;
      }

      this.loader.isRequestPending = true;
      try {
        const fromData = {
          id: this.waitingRequest.id,
          reason: this.reason,
          gCoins: this.form.gCoins,
        } as WaitingWithdrawalAcceptForm;

        await this.$store.dispatch(Actions.gCoins.acceptRequest, fromData);

        const toastText = this.$t(
          'admin-panel.gcoins.tabs.waiting-requests.toasts.accepted',
          { geekName: this.geekName },
        ) as string;
        ToastsService.success(toastText);
        this.$bvModal.hide('accept-request-modal');
        this.$emit('refresh');
      } finally {
        this.loader.isRequestPending = false;
      }
    },
    resetModal() {
      this.form = resetModel(this.form);
    },
  },
});
